import Navbar from "../../../components/dashboard/navbar/Navbar"
import Settlements from "../../../components/dashboard/settlements/Settlements"
import Sidebar from "../../../components/dashboard/sidebar/Sidebar"
import styles from "../layout.module.css"

import { selectSideNavOpen } from "../../../redux/slices/sharedSlice"
import { toggleSideNav } from "../../../redux/slices/sharedSlice"
import { useSelector } from "react-redux";
import { useState } from "react";

const SettlementsPage = () => {

    const open = useSelector(selectSideNavOpen)
    
    return (
        <section className={styles.pageContainer}>
            <div className={`${open ? styles.leftBarOpen : styles.leftBarClosed}`}>
                <Sidebar />
            </div>
            <div className={`${open ? styles.rightBarOpen : styles.rightBarClosed}`}>
                <Navbar page="Settlements" />
                <div className={styles.mainBar}>
                    <Settlements />
                </div>
            </div>
        </section>
    )
}

export default SettlementsPage